export enum PermissionReceiptsOptions {
  RECEIPTS_COMMON_LOGIN = 'recaudos',
  RECEIPTS_MANAGER_LIST = '/recaudos/historial',
  RECEIPTS_DASHBOARD_LIST = '/recaudos/dashboard',
}
